import React from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import { Icon } from '@paypalcorp/pp-react'

import {
  shareURLByFacebook,
  shareURLByMessenger,
  shareByTwitter,
  shareByWhatsApp,
  shareByEmail,
  shareBySMS,
} from 'consumerweb-sharing'

import { trackClick } from 'lib/fpti_analytics'

const i18n = getI18n('components/share_buttons')

const propTypes = {
  showFacebook: PropTypes.bool,
  showMessenger: PropTypes.bool,
  showTwitter: PropTypes.bool,
  showWhatsApp: PropTypes.bool,
  showEmail: PropTypes.bool,
  showSms: PropTypes.bool,
  showSubtext: PropTypes.bool,
  shareText: PropTypes.string,
  className: PropTypes.string,
  emailSubject: PropTypes.string,
  emailBody: PropTypes.string,
}

const handleIconClick = (socialNetwork, props, event) => {
  event.preventDefault()
  const shareText = props.shareText || props.shareUrl

  switch (socialNetwork) {
    case 'facebook':
      shareURLByFacebook(shareText, 640, 480)
      break

    case 'messenger':
      shareURLByMessenger(shareText, props.appId, window.location.href)
      break

    case 'twitter':
      shareByTwitter(shareText, 640, 480)
      break

    case 'whats-app':
      shareByWhatsApp(shareText)
      break

    case 'email':
      shareByEmail(props.emailSubject, props.emailBody || shareText)
      break

    case 'sms':
      shareBySMS(shareText)
      break

    default:
      break
  }
  trackClick({
    clickName: 'social_media',
    data: {
      socialapp: socialNetwork,
    },
  })
}

const displayComponent = display => {
  if (!display) {
    return
  }
}

export const EmailSharing = props => {
  displayComponent(props.showEmail)

  return (
    <div
      className={props.className}
      data-pa-click="shareEmail"
      onClick={e => handleIconClick('email', props, e)}
    >
      <Icon name="share-email" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('email')}</div>}
    </div>
  )
}

export const TwitterSharing = props => {
  displayComponent(props.showTwitter)

  return (
    <div
      className={props.className}
      data-pa-click="shareTwitter"
      onClick={e => handleIconClick('twitter', props, e)}
    >
      <Icon name="share-twitter" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('twitter')}</div>}
    </div>
  )
}

export const FacebookSharing = props => {
  displayComponent(props.showFacebook)

  return (
    <div
      className={props.className}
      data-pa-click="shareFacebook"
      onClick={e => handleIconClick('facebook', props, e)}
    >
      <Icon name="share-facebook" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('facebook')}</div>}
    </div>
  )
}

export const MessengerSharing = props => {
  displayComponent(props.showMessenger)

  return (
    <div
      className={props.className}
      data-pa-click="shareMessenger"
      onClick={e => handleIconClick('messenger', props, e)}
    >
      <Icon name="share-messenger" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('messenger')}</div>}
    </div>
  )
}

export const WhatsAppSharing = props => {
  displayComponent(props.showWhatsApp)

  return (
    <div
      className={props.className}
      data-pa-click="shareWhatsApp"
      onClick={e => handleIconClick('whats-app', props, e)}
    >
      <Icon name="share-whatsapp" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('whatsapp')}</div>}
    </div>
  )
}

export const SmsSharing = props => {
  displayComponent(props.showSms)

  return (
    <div
      className={props.className}
      data-pa-click="shareSms"
      onClick={e => handleIconClick('sms', props, e)}
    >
      <Icon name="share-mobile" size="xl" />
      {props.showSubtext && <div stylename="sub-text">{i18n('sms')}</div>}
    </div>
  )
}

SmsSharing.propTypes = propTypes
EmailSharing.propTypes = propTypes
TwitterSharing.propTypes = propTypes
WhatsAppSharing.propTypes = propTypes
FacebookSharing.propTypes = propTypes
MessengerSharing.propTypes = propTypes
